import {Field, useFormikContext} from "formik";
import {Button, Col, Figure, Form, InputGroup, Row, Stack} from "react-bootstrap";
import React, {Children, useState} from "react";
import {config} from "../../utils2";
import {Link} from "react-router-dom";
import {useTouch} from "../../hooks";
import {useDarkMode} from "../../context";

export function SingleText({
                               name,
                               label,
                               placeholder,
                               tip,
                               min,
                               step,
                               rows,
                               prefix,
                               postfix,
                               aria,
                               autoComplete,
                               maxLength,
                               autoFocus = false,
                               type = "text",
                               disabled,
                               ...props
                           }) {
    const label1 = label === undefined ? name : label
    const as = type === "textarea" ? "textarea" : "input"

    return <>
        <Field name={name}>
            {({field, meta}) =>
                <Form.Group controlId={name + "Id"} className="mb-2" {...props}>
                    {label1 ? <Form.Label column="" className="text-capitalize text-body-secondary">{label1}</Form.Label> : <div className="py-3"/>}
                    <InputGroup hasValidation>
                        {prefix && <InputGroup.Text>{prefix}</InputGroup.Text>}
                        <Form.Control type={type} {...field} value={field.value ?? ""} isInvalid={meta.touched && !!meta.error} placeholder={placeholder} as={as}
                                      min={min} rows={rows}
                                      step={step}
                                      autoComplete={autoComplete} aria-label={aria || label1} maxLength={maxLength} autoFocus={autoFocus} disabled={disabled}/>
                        {postfix && <InputGroup.Text>{postfix}</InputGroup.Text>}
                        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                    </InputGroup>
                    {tip != null && <Form.Text muted className="">{tip}</Form.Text>}
                </Form.Group>
            }
        </Field>
    </>
}

export function PasswordButton({name, label, placeholder, tip, position = "left", aria, maxLength, autoComplete, ...props}) {
    const [show, setShow] = useState(false);

    const label1 = label === undefined ? name : label

    return <>
        <Field name={name}>
            {({field, meta}) => <Form.Group controlId={name + "Id"} className="mb-2" {...props}>
                {label1 !== null && <Form.Label column="" className="text-capitalize text-body-secondary">{label1}</Form.Label>}
                <InputGroup hasValidation>
                    {position === "left" &&
                        <Button variant={show ? "secondary" : "outline-secondary"} checked={show}
                                onClick={() => setShow(show => !show)}>
                            {show ?
                                <>
                                    <span className="d-none d-sm-block">Hide</span>
                                    <span className="bi-eye-slash d-block d-sm-none"/>
                                </> :
                                <>
                                    <span className="d-none d-sm-block">Show</span>
                                    <span className="bi-eye d-block d-sm-none"/>
                                </>
                            }
                        </Button>}
                    <Form.Control type={show ? "text" : "password"} {...field} value={field.value ?? ""} isInvalid={meta.touched && !!meta.error}
                                  placeholder={placeholder}
                                  autoComplete={autoComplete} aria-label={aria || label1} maxLength={maxLength}/>
                    {position === "right" &&
                        <Button variant={show ? "secondary" : "outline-secondary"} checked={show}
                                onClick={() => setShow(show => !show)}>
                            {show ?
                                <>
                                    <span className="d-none d-sm-block">Hide</span>
                                    <span className="bi-eye-slash d-block d-sm-none"/>
                                </> :
                                <>
                                    <span className="d-none d-sm-block">Show</span>
                                    <span className="bi-eye d-block d-sm-none"/>
                                </>
                            }
                        </Button>}
                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                </InputGroup>
                {tip != null && <Form.Text muted>{tip}</Form.Text>}
            </Form.Group>}
        </Field>
    </>
}

export function SingleTextWithClearButton({
                                              name,
                                              label,
                                              placeholder,
                                              buttonVariant = "secondary",
                                              maxLength,
                                              disabled,
                                              type = "text",
                                              ...props
                                          }) {
    const {setFieldValue} = useFormikContext()
    const label1 = label === undefined ? name : label;

    const handleClear = () => {
        setFieldValue(name, "");
    };

    return (
        <Field name={name}>
            {({field, meta}) => (
                <Form.Group controlId={name + "Id"} className="mb-2" {...props}>
                    {label1 ? (
                        <Form.Label column="" className="text-capitalize text-body-secondary">
                            {label1}
                        </Form.Label>
                    ) : (
                        <div className="py-3"/>
                    )}

                    <InputGroup hasValidation>
                        <Form.Control
                            type={type}
                            {...field}
                            value={field.value ?? ""}
                            isInvalid={meta.touched && !!meta.error}
                            placeholder={placeholder}
                            maxLength={maxLength}
                            disabled={disabled}
                        />
                        <Button
                            variant={buttonVariant}
                            type="button"
                            onClick={handleClear}
                            disabled={disabled || !field.value}
                        >
                            <i className="bi bi-x-lg"/>
                        </Button>

                        <Form.Control.Feedback type="invalid">
                            {meta.error}
                        </Form.Control.Feedback>
                    </InputGroup>
                </Form.Group>
            )}
        </Field>
    );
}


export function SelectText({name, label, tip, defaultSelection, defaultValue, children, disabled, ...props}) {
    const label1 = label === undefined ? name : label

    return <Field name={name}>
        {({field, meta}) => <Form.Group controlId={name + "Id"} className="mb-2" {...props}>
            {label1 ? <Form.Label column="" className="text-capitalize text-body-secondary">{label1}</Form.Label> : <div className="py-3"/>}
            <Form.Select {...field} isInvalid={meta.touched && !!meta.error} defaultValue={defaultValue} disabled={disabled}>
                <option disabled value="">{defaultSelection || "-- select an option --"}</option>
                {children}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            {tip != null && <Form.Text muted>{tip}</Form.Text>}
        </Form.Group>}
    </Field>
}

export function CheckText({name, label, type = "checkbox", reverse, ...props}) {
    const label1 = label === undefined ? name : label

    return <Field name={name} type={type}>
        {({field, meta, form}) => <Form.Group controlId={name + "Id"} className="mb-2" {...props}>
            <Form.Check {...field} reverse={reverse} type={type} label={label1}
                        isInvalid={meta.touched && !!meta.error} feedbackType="invalid" feedback={meta.error}/>
            {/*TO MAKE THE CHECKBOX UNCHECKED ADD checked={!!field.value} onChange={(e) => form.setFieldValue(name, e.target.checked)}*/}
        </Form.Group>}
    </Field>
}

export function SwitchText({name, label, tip, ...props}) {
    const touch = useTouch()

    const label1 = label === undefined ? name : label

    return <Stack direction="horizontal" className="my-2">
        <Stack>
            <Form.Label column="" className="mb-0 fw-semibold text-capitalize text-body-secondary">{label1}</Form.Label>
            {tip != null && <Form.Text className={`${touch ? "text-primary fw-light" : ""}`}>{tip}</Form.Text>}
        </Stack>

        <Field name={name} type="checkbox">
            {({field, meta}) => <Form.Group controlId={name + "Id"} {...props}>
                <Form.Check {...field} reverse type="switch" label={field.value ? "On" : "Off"} isInvalid={meta.touched && !!meta.error}
                            feedbackType="invalid"
                            feedback={meta.error}/>
            </Form.Group>}
        </Field>
    </Stack>
}

export function ToggleText({name, label, items, fullspace, wrap, onChange, ...props}) {
    return <div>

        <Stack className="my-2" {...props}>

            <Form.Label column="" className="mb-0 text-capitalize text-body-secondary">{label}</Form.Label>

            <Stack direction="horizontal" className="mt-2">
                <Field name={name}>
                    {({field, form, meta}) => (
                        <>
                            <InputGroup className={`d-flex ${wrap ? "flex-wrap" : "flex-nowrap"}`}>
                                {items.map((item, i) => (
                                    <Button
                                        key={i}
                                        variant={`${field.value === item.id ? '' : 'outline-'}${item.variant}`}
                                        onClick={() => {
                                            form.setFieldValue(name, item.id)
                                            if (typeof onChange === 'function') {
                                                if (field.value !== item.id) {
                                                    onChange(item.id)
                                                }
                                            }
                                        }}
                                        disabled={item.disabled}
                                        // className={fullspace ? 'flex-grow-1' : undefined}
                                        className={`${fullspace ? 'flex-grow-1' : ''} ${wrap ? 'mb-2 ' : ''}`}
                                    >
                                        {/*{item.name}*/}
                                        {item.icon ? <>
                                                <span className="d-lg-none"><i className={item.icon}></i></span>
                                                <span className="d-none d-lg-inline">{item.name}</span>
                                            </>
                                            : item.name}
                                    </Button>
                                ))}
                            </InputGroup>
                            {meta.touched && meta.error && (
                                <div className="invalid-feedback d-block">{meta.error}</div>
                            )}
                        </>
                    )}
                </Field>
            </Stack>
        </Stack>
    </div>
}

export function SingleToggleText({name, label, items, fullspace, ...props}) {

    return <div>
        <Stack className="my-2" {...props}>
            <Form.Label column="" className="mb-0 text-capitalize text-body-secondary">
                {label}
            </Form.Label>

            <Stack direction="horizontal" className="mt-2">
                <Field name={name}>
                    {({field, form, meta}) => {
                        let currentIndex = items.findIndex(item => item.id === field.value);
                        if (currentIndex === -1) currentIndex = 0; // fallback if invalid value

                        const currentItem = items[currentIndex];
                        const nextItem = items[(currentIndex + 1) % items.length]

                        return (
                            <>
                                <Button
                                    variant={currentItem.variant}
                                    onClick={() => form.setFieldValue(name, nextItem.id)}
                                    className={fullspace ? 'flex-grow-1' : undefined}
                                    disabled={currentItem.disabled}
                                >
                                    {currentItem.icon ? (
                                        <>
                                            <span className="d-lg-none"><i className={currentItem.icon}></i></span>
                                            <span className="d-none d-lg-inline">{currentItem.name}</span>
                                        </>
                                    ) : (
                                        <span>{currentItem.name}</span>
                                    )}
                                </Button>
                                {meta.touched && meta.error && (
                                    <div className="invalid-feedback d-block">{meta.error}</div>
                                )}
                            </>
                        );
                    }}
                </Field>
            </Stack>
        </Stack>
    </div>
}

export function FileUpload({name, label, placeholder, tip, aria, ...props}) {
    const label1 = label === undefined ? name : label

    return <Field name={name}>
        {({field, meta}) =>
            <Form.Group controlId={name + "Id"} {...props}>
                {label1 !== null && <Form.Label column="" className="text-capitalize text-body-secondary">{label1}</Form.Label>}
                <InputGroup hasValidation>
                    <Form.Control type="file" name={name}
                                  onChange={e => field.onChange({target: {name: name, value: e.target.files[0]}})}
                                  onBlur={field.onBlur} isInvalid={!!meta.error}
                                  placeholder={placeholder} aria-label={aria || label1}/>
                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                </InputGroup>
                {tip != null && <Form.Text muted>{tip}</Form.Text>}
            </Form.Group>
        }
    </Field>
}


export function ColumnizeText({children, ...props}) {
    const columns = 12 / Children.toArray(children).length

    return <Row {...props} >
        {children.map((item, index) => (
            <Col key={index} md={columns}>
                {item}
            </Col>
        ))}
    </Row>
}

export function FigureText({path, alt, caption, onClick, children, ...props}) {
    const [showFig, setShowFig] = useState(true)
    const {darkMode} = useDarkMode()

    return <Stack direction="horizontal" gap={2} className="align-items-start" {...props}>
        <Figure className="" onClick={onClick} style={{cursor: "pointer"}}>
            {showFig ? <Figure.Image
                    className="img-thumbnail"
                    src={config.get_public_media(path, "thumb", darkMode)}
                    alt={alt}
                    height="120px"
                    width="120px"
                    loading="lazy"
                    onError={() => setShowFig(false)}
                />
                :
                <div className="d-flex justify-content-center align-items-center img-thumbnail mb-2" style={{height: '120px', width: '120px'}}>
                    <i className="bi bi-ban " style={{fontSize: '70px'}}></i>
                </div>}
            <Figure.Caption className="">{caption}</Figure.Caption>
        </Figure>
        {children}
    </Stack>
}